module.exports = __webpack_public_path__ + "img/Personal-Details1.81dd2bc7.svg";